<router-outlet>
    <ngx-spinner class="text-center" bdColor="rgba(49,59,13,0.75)" size="medium" color="#fff" type="pacman"
        [fullScreen]="true">
        <p style="color: white" class="text-center"> Verdaue gerade - bin fast fertig… </p>
    </ngx-spinner>
</router-outlet>